import zhElementUi from 'element-ui/lib/locale/lang/zh-CN'

module.exports = {
    common: {
        // UI ELEMENT
        submit: '提交',
        cancel: '取消',
        sendCode: '发送验证码',
        verifyCode: '验证码',
        reminder: '提示',
        operation: '操作',
        statusNormal: "正常",
        statusDisabled: "禁用",
        // MSG
        sendCodeTip: '',
        sendCodeSuccess: '验证码发送成功',
        codeSent: '验证码已发送，请5分钟后重新发送',
        sendCodeFail: '验证码发送失败，请稍后再试',
        emailNotRegister: '电子邮件未注册',
        usernameRequried: '请输入用户名',
        usernameFormat: '用户名为4-16个字符，包括字母、数字和下划线，以字母开头',
        emailRequried: '请输入电子邮件',
        emailFormat: '请输入有效的邮件地址',
        verifyCodeRequried: '请输入验证码',
        verifyCodeFormat: '请输入有效的验证码',
        veriryCodeMismatch: '验证码不正确或已过期',
        passwordRequried: '请输入密码',
        passwordFormat: '密码为8-20个字符，至少包含大小写字母和数字',
        noData: '暂无数据',
        tyrLater: '无可用服务，请稍后再试',
        copySuccess: '复制成功',
        copyFailed: '复制失败',
    },
    index: {
        // UI ELEMENT
        documentation: '文档',
        login: '登录',
        signup: '注册',
        logout: '退出',
        lang: 'English',
        gatewayTitle: 'Wanchain网络之门',
        gatewayInfo: 'iWan易用的API助您安全可靠地访问Wanchain的完整节点服务。 我们为您管理区块链基础架构，使您能专注于构建优秀的分布式应用。',
        benefitTitle: '为什么选择IWAN',
        benefit1: '无需自行维护节点',
        benefit1info: '不再需要安装、配置和维护昂贵的区块链基础设施。',
        benefit2: '可靠、快速部署',
        benefit2info: '我们的RPC服务器提供业界顶尖的可靠性，助您快速部署应用。',
        benefit3: '跨链能力',
        benefit3info: '无缝调用跨链能力，无需管理不同区块链的基础架构。',
        summary: '轻松访问Wanchain的跨链生态系统',
        copyright: '版权所有©2019年 WANCHAIN FOUNDATION LTD',
        // MSG
        logoutWndInfo: '确认退出登录？',
    },
    signup: {
        // UI ELEMENT
        title: '免费开始您的iWan之旅',
        username: '用户名',
        email: '邮件地址',
        password: '密码',
        confirm: '确认密码',
        signup: '注册',
        privacyBegin: '注册即表示您已阅读并同意',
        service: '服务条款',
        privacyAnd: ' 和',
        privacy: '隐私政策',
        privacyEnd: '。',
        haveAccount: '已经有账号？',
        login: '登录',        
        // MSG
        usernameUsed: '用户名已被使用',
        emailUsed: '邮件地址已注册',
        confirmPwdRequried: '请输入确认密码',
        confirmPwdMismatch: '密码和确认密码不匹配',
        registerSuccess: '注册成功'
    },        
    login: {
        // UI ELEMENT
        title: '请使用iWan账号登录',
        user: '用户名 / 邮件地址',
        password: '密码',
        login: '登录',
        forgotPwd: '忘记密码？',
        notMember: '还没有账号？',
        signup: '注册',
        // MSG
        emailNameRequired: '请输入用户名或电子邮件',
        emailNameFormat: '请输入有效的用户名或邮件地址',
        incorrectPwd: '用户名/电子邮件或密码错误',
        accountAbnormal: '账户异常，请联系管理员'
    },
    resetPwd: {
        // UI ELEMENT
        title: '重置密码',
        email: '邮件地址',
        reset: '重置密码',
        back: '回到',
        login: '登录',
        // MSG
        mailReminder: '临时密码已发送到您的电子邮件，请使用它登录并更改密码'
    },
    projectManage: {
        // UI ELEMENT
        // main window
        title: '项目管理',
        create: '新建项目',
        edit: '编辑',
        delete: '删除',
        name: '项目名称',
        apikey: 'API KEY',
        secret: 'SECRET KEY',
        serviceType: '服务类型',
        status: '状态',
        createDate: '创建时间',
        operation: '操作',
        // endpoint
        endpoint: '节点',
        // create window
        createWndTitle: '新建',
        createWndName: '名称',
        // edit window
        editWndTitle: '编辑',
        editWndName: '名称',
        // delete window
        deleteWndInfo: '确认删除此项目？',
        // MSG
        nameRequired: '输入项目名称',
        nameFormat: '1-16个字符，包括字母、数字和下划线',
        nameUsed: '项目名称已被使用',
        deleteSuccess: '删除项目成功',
        editSuccess: '修改项目成功',
        createSuccess: '新建项目成功'
    },
    accountManage: {
        // UI ELEMENT
        title: '我的账号',
        accountInfo: '账号信息',
        changePwd: '修改密码',
        changeEmail: '修改邮件地址'
    },
    accountInfo: {
        // UI ELEMENT
        title: '账号信息',
        username: '用户名',
        email: '邮件地址',
        role: '角色',
        level: '级别',
        status: '状态',
        registerDate: '注册时间',
        lastDate: '上次登录时间',
        lastIp: '上次登录IP'
    },
    changePwd: {
        // UI ELEMENT
        title: '修改密码',
        oldPassword: '旧密码',
        newPassword: '新密码',
        retypePassword: '确认新密码',
        // MSG
        oldPwdRequried: '输入当前密码',
        newPwdRequried: '输入新密码',
        confirmNewPwd: '确认新密码',
        confirmNewPwdMismatch: '新密码和确认密码不匹配',
        changeSuccess: '修改密码成功',
        oldPwdIncorrect: '旧密码不正确'
    },
    changeEmail: {
        // UI ELEMENT
        title: '修改邮件地址',
        password: '密码',
        newEmail: '新邮件地址',
        // MSG
        changeSuccess: '修改邮件地址成功',
        pwdIncorrect: '密码不正确'
    },
    admin: {
        // UI ELEMENT
        title: '管理员',
        users: '用户管理',
        projects: '项目管理',
        totalUsers: '用户总数：',
        totalProjects: '，项目总数：',
        searchUser: '搜索用户名/邮箱',
        searchProject: '搜索用户名/邮箱/API key'
    },
    stats: {
        // UI ELEMENT
        title: '统计',
        allProjects: '所有项目',
        last24h: '最近24小时',
        last7d: '最近7天',
        last30d: '最近30天',
        totalMethodCalls: '总调用次数',
        projectMethodCalls: '项目调用次数',
        topnMethodCalls: '方法调用 ',
        topnMethodCallsSummary: '汇总',
        chartHeatmap: '调用次数热力图',
    },
    ...zhElementUi
}


// WEBPACK FOOTER //
// ./src/assets/i18n/zh-cn.js